export default function (type) {
  if (type == "Graduação") {
    return ["o", "Curso"];
  }
  if (type == "Pós-graduação") {
    return ["a", "Linha de Pesquisa"];
  }
  if (type == "Técnico") {
    return ["o", "Cargo"];
  }
  if (type == "Docente") {
    return ["a", "Área"];
  }
}
